import * as klinecharts from "klinecharts";

let ellipseRegistered = false;

export async function registerEllipseOverlay() {
  if (ellipseRegistered) return;
  ellipseRegistered = true;

  try {
    klinecharts.registerFigure({
      name: "ellipse",
      draw: (ctx: CanvasRenderingContext2D, attrs: any, styles: any) => {
        const cx = attrs.cx ?? 0;
        const cy = attrs.cy ?? 0;
        const rx = attrs.rx ?? 0;
        const ry = attrs.ry ?? 0;
        if (rx <= 0 || ry <= 0) return;

        ctx.beginPath();
        ctx.ellipse(cx, cy, rx, ry, 0, 0, 2 * Math.PI);

        // draw background fill
        if (styles.style === "fill" || styles.style === "stroke_fill" || styles.style === "stroke_fill_close") {
          ctx.fillStyle = styles.color || "transparent";
          ctx.fill();
        }

        // draw stroke outline
        if (styles.style === "stroke" || styles.style === "stroke_fill" || styles.style === "stroke_fill_close" || !styles.style) {
          ctx.strokeStyle = styles.borderColor || "var(--color-fib-level)";
          ctx.lineWidth = styles.borderSize ?? 1;
          if (styles.borderStyle === "dash") {
            ctx.setLineDash([4, 4]);
          } else {
            ctx.setLineDash([]);
          }
          ctx.stroke();
        }
        ctx.closePath();
      },
      checkEventOn: (coordinate: { x: number; y: number }, attrs: any, styles: any) => {
        const cx = attrs.cx ?? 0;
        const cy = attrs.cy ?? 0;
        const rx = attrs.rx ?? 0;
        const ry = attrs.ry ?? 0;
        if (rx <= 0 || ry <= 0) return false;

        const dx = coordinate.x - cx;
        const dy = coordinate.y - cy;
        const val = (dx * dx) / (rx * rx) + (dy * dy) / (ry * ry);

        const hasFill = styles.style === "fill" || styles.style === "stroke_fill" || styles.style === "stroke_fill_close" || (styles.color && styles.color !== "transparent");
        if (hasFill) {
          return val <= 1.05;
        }

        const TOLERANCE = 6;
        const outerRx = rx + TOLERANCE;
        const outerRy = ry + TOLERANCE;
        const innerRx = Math.max(0.1, rx - TOLERANCE);
        const innerRy = Math.max(0.1, ry - TOLERANCE);

        const valOuter = (dx * dx) / (outerRx * outerRx) + (dy * dy) / (outerRy * outerRy);
        const valInner = (dx * dx) / (innerRx * innerRx) + (dy * dy) / (innerRy * innerRy);

        return valOuter <= 1.0 && valInner >= 1.0;
      }
    });

    klinecharts.registerOverlay({
      name: "ellipse",
      totalStep: 3,
      needDefaultPointFigure: true,
      needDefaultXAxisFigure: false,
      needDefaultYAxisFigure: false,
      styles: {
        polygon: { color: "transparent" },
        line: { color: "var(--color-fib-level)", size: 1 },
      },
      createPointFigures: ({ coordinates, styles }: any) => {
        if (coordinates.length < 2) return [];
        const x1 = coordinates[0].x;
        const y1 = coordinates[0].y;
        const x2 = coordinates[1].x;
        const y2 = coordinates[1].y;

        const cx = (x1 + x2) / 2;
        const cy = (y1 + y2) / 2;
        const rx = Math.abs(x2 - x1) / 2;
        const ry = Math.abs(y2 - y1) / 2;

        const rectStyles = styles?.rect ?? {};

        return [{
          type: "ellipse",
          attrs: { cx, cy, rx, ry },
          styles: {
            style: "stroke_fill_close",
            color: rectStyles.color || "transparent",
            borderColor: rectStyles.borderColor || "var(--color-fib-level)",
            borderSize: rectStyles.borderSize ?? 1,
            borderStyle: rectStyles.borderStyle || "solid",
          },
        }];
      },
    });
  } catch (err) {
    console.error("Failed to register ellipse overlay:", err);
  }
}
